import AjaxHandler from './ajax-handler';

class Pagination {
	constructor() {
		this.$ = jQuery;
		this.ajax = new AjaxHandler();
	}

	initPagination() {
		var current = 0;
		var page = 0;
		var href = '';

		var self = this;

		$(document).on('click', 'ul.pagination .page-item', function (e) {
			var $elem = $(this);
			var $pageNum = $elem.find('.page-numbers');
			var $currentElem = $elem.parent().find('.page-item.active');

			if ($currentElem.length) {
				current = parseInt($currentElem.find('.page-numbers').html());
			}

			e.preventDefault();

			if (!$pageNum || $pageNum.hasClass('current') || $pageNum.hasClass('.dots')) {
				return;
			}

			href = $pageNum.href;
			page = parseInt($pageNum.html());

			if ($pageNum.hasClass('next')) {
				page = current + 1;
			} else if ($pageNum.hasClass('prev')) {
				page = current - 1;
			}

			let settings = $pageNum.closest('nav').data('settings');

			self.paginationHandler(page, href, settings);
		});
	}

	paginationHandler(page, href, settings) {
		let parsedSettings = JSON.parse(atob(settings));

		if (!parsedSettings) {
			return false;
		}

		let postsContainer = parsedSettings.posts_container;
		let paginationContainer = parsedSettings.pagination_container;

		$(parsedSettings.posts_container).LoadingOverlay('show', {
			imageClass: 'jquery-loading-overlay-icon',
			image: ajax.templateUrl + '/assets/svg/loading.svg',
			imageResizeFactor: 1,
			zIndex: 800,
			background: 'rgba(255, 255, 255, 0.02)'
		});

		$('ul.pagination').css('opacity', .5).css('pointer-events', 'none');

		var form_data = new FormData();
		form_data.append('settings', settings);
		form_data.append('paged', page);
		form_data.append('action', 'paginate_posts');
		form_data.append('nonce', ajax.nonce);

		this.ajax._request(form_data, 'POST', postsContainer).then((response) => {
			$(parsedSettings.posts_container).LoadingOverlay('hide');
			if (response && response.data.posts_html) {
				$(postsContainer).html(response.data.posts_html);
				$(paginationContainer).html(response.data.pagination_html);

				$('ul.pagination').css('opacity', 1).css('pointer-events', 'default');

				if (parsedSettings.scroll_to) {
					$([document.documentElement, document.body]).animate({
						scrollTop: $(parsedSettings.scroll_to).offset().top
					}, 500);
				}
			} else {
				$('ul.pagination').css('opacity', 1).css('pointer-events', 'default');
				$(postsContainer).html('<h3 class="text-center py-4">' + response.no_posts + '</h3>');
			}
		});

	}
}

export default Pagination;
